<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="assets/images/logo/beliv-color.png" alt="brand-logo" width="78px" *ngIf="coreConfig.layout.skin != 'dark'" />
          <img src="assets/images/logo/beliv-blanco.png" alt="brand-logo" width="78px" *ngIf="coreConfig.layout.skin == 'dark'" />
        </span>
        <!-- <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2> -->
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->

    <!-- Bookmark -->
    <!-- <app-navbar-bookmark></app-navbar-bookmark> -->
    <!--/ Bookmark -->
  </div>
  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- Language selection -->
    <li ngbDropdown class="nav-item dropdown dropdown-language" *ngIf="_translateService.currentLang">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
        </a>
      </div>
    </li>
    <!--/ Language selection -->

    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li>
    <!--/ Toggle skin -->

    <!-- Navbar Pin Toggle -->
    <li class="nav-item d-none d-xl-block navbar-pin-item" *ngIf="horizontalMenu">
      <a class="nav-link nav-link-style btn"
         (click)="toggleNavbarPin()"
         [title]="navbarPinned ? 'Activar auto-ocultar al hacer scroll' : 'Fijar navbar siempre visible'">
        <span [data-feather]="navbarPinned ? 'lock' : 'unlock'" [inner]="true" class="ficon font-medium-5 feather navbar-pin-icon"></span>
      </a>
    </li>
    <!--/ Navbar Pin Toggle -->

    <!-- Access BIX -->
    <li class="nav-item d-none d-lg-block" *ngIf="canSeeBIX">
      <a class="nav-link nav-link-style btn" (click)="toggleBryant()" ngbPopover="{{'BELIVPEDIA.MESSAGES.VIEW_BIX' | translate}}" 
        #popoverBixNavbar="ngbPopover" container="body" triggers="manual" closeDelay="60000">
        <span class="ficon font-medium-5 feather">
          <img src="https://belivthumbs.blob.core.windows.net/prod/bot.ico" alt="Bryant" height="36" width="36" />
        </span>
      </a>
    </li>
    <!--/ Access BIX -->

    <!-- Search -->
    <!-- <app-navbar-search></app-navbar-search> -->
    <!--/ Search -->

    <!-- Cart -->
    <!-- <app-navbar-cart></app-navbar-cart> -->
    <!--/ Cart -->

    <!-- Notification -->
    <!-- <app-navbar-notification></app-navbar-notification> -->
    <!--/ Notification -->

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <ng-container *ngIf="this.currentUser">
          <div class="user-nav d-sm-flex d-none">
            <span class="user-name font-weight-bolder">
              {{ this.currentUser.person.name }} {{ this.currentUser.person.surname }}
            </span>
            <!-- <span class="user-status">{{ this.currentUser.role }}</span> -->
          </div>
          <span class="avatar" [ngClass]="{'mr-1 ml-0 bg-light-primary': !this.profilePhoto || this.profilePhoto.length == 0}">
            <img class="round" [src]="this.profilePhoto" alt="avatar" height="40" width="40"
              *ngIf="this.profilePhoto && this.profilePhoto.length > 0; else customAvatar" />
            <ng-template #customAvatar>
              <div class="avatar-content">{{ this.currentUser.person.name | slice:0:1 }}{{this.currentUser.person.surname | slice:0:1 }}</div>
            </ng-template>
            <span class="avatar-status-online"></span>
          </span>
        </ng-container>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <!-- <a ngbDropdownItem [routerLink]="['/pages/profile']">
          <span [data-feather]="'user'" [class]="'mr-50'"></span> Perfil
        </a> 
        <a ngbDropdownItem [routerLink]="['/apps/email']">
          <span [data-feather]="'mail'" [class]="'mr-50'"></span> Inbox
        </a>
        <a ngbDropdownItem [routerLink]="['/apps/todo']">
          <span [data-feather]="'check-square'" [class]="'mr-50'"></span> Task
        </a>
        <a ngbDropdownItem [routerLink]="['/apps/chat']">
          <span [data-feather]="'message-square'" [class]="'mr-50'"></span> Chats
        </a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem [routerLink]="['/pages/account-settings']">
          <span [data-feather]="'settings'" [class]="'mr-50'"></span> Settings
        </a>
        <a ngbDropdownItem [routerLink]="['/pages/pricing']">
          <span [data-feather]="'credit-card'" [class]="'mr-50'"></span> Pricing
        </a> 
        <a ngbDropdownItem [routerLink]="['/pages/faq']">
          <span [data-feather]="'help-circle'" [class]="'mr-50'"></span> FAQ
        </a> -->
        <a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span>{{'COMMON.BUTTONS.LOG_OUT' | translate }}</a>
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>
